import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Avatar from '@base/Avatar/Avatar';
import P2 from '@base/P2/P2';
import H6 from '@base/H6/H6';
import CheckBig from '@icon/CheckBig';
import { dateWithTime } from '@utils/dates';
import { Spacings } from '../../../styleConstants';

const UserInfo = styled.div`
  display: flex;
  align-items: ${({ isSubtitle }) => (isSubtitle ? 'normal' : 'center')};
`;

const AuthorNameWrapper = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  display: flex;
  align-items: center;
`;

const VerifiedIcon = styled(CheckBig)`
  margin-left: ${Spacings.SPACING_1B};
`;

const Posted = styled(P2)`
  margin-left: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
`;

const StyledAvatar = styled(Avatar)`
  cursor: auto;
`;

const Subtitle = styled(P2)`
  font-size: 14px;
  line-height: 150%;
  color: var(--color-text-primary);
  margin-left: 16px;
`;

const AuthorHeader = ({ author, created_at, subtitle }) => {
  const fullName = `${author?.first_name} ${author?.last_name}`;
  return (
    <UserInfo isSubtitle={!!subtitle}>
      <StyledAvatar src={author?.avatar_v1 || author?.avatar} size="48px" />
      <div>
        <AuthorNameWrapper>
          <H6 color="var(--color-text-primary)">{fullName}</H6>
          {author.is_verified_educator && (
            <VerifiedIcon color="var(--color-i-blue)" />
          )}
        </AuthorNameWrapper>
        {subtitle && <Subtitle lineClamp={1}>{subtitle}</Subtitle>}
        <Posted color="var(--color-text-secondary)">
          {dateWithTime(created_at)}
        </Posted>
      </div>
    </UserInfo>
  );
};

export default AuthorHeader;

AuthorHeader.propTypes = {
  author: PropTypes.objectOf(PropTypes.any),
  subtitle: PropTypes.string,
  created_at: PropTypes.string.isRequired
};

AuthorHeader.defaultProps = {
  subtitle: null,
  author: {}
};
